import { Experiment } from "../../../../types";

export const PUBLISHED_EXPERIENCE_LABELS = {
  type: "Experience",
  changes: "Changes",
} as const;

export const isPublishedExperience = (experiment?: Experiment | null): boolean => {
  return Boolean(
    experiment?.published_at &&
      experiment?.published_from_experiment_id &&
      experiment?.published_from_variant_id
  );
};
